// <form-notice> can be used to conditionally show information based on the current selection.


import {
  debounce,
  isValidAssessmentItemId,
  setupLogger,
} from '../utils.js'

const { logger, loggerError } = setupLogger('FormNotice', 'salmon')


export default class FormNotice extends HTMLElement {
  constructor() {
    super()
    // logger(this)

    this.classList.add('notice')
    this.showCondition = this.getAttribute('if-selected')

    const heading = this.getAttribute('heading')
    const initialContents = this.innerHTML
    this.render(
      heading,
      initialContents
    )
  }

  connectedCallback() {
    this.form = this.closest('[data-assessment-form]')
    this.assessmentId = this.form.getAttribute('data-assessment-form')

    // Retrieve any selections saved to localStorage for an immediate update:
    const cachedSelection = Object.keys(localStorage)
    this.hidden = !this.shouldShow(cachedSelection, this.assessmentId)

    // Debounce the listener's callback a bit to batch updates:
    document.addEventListener('reef:signal-risk-selection', debounce((event) => {
      logger('heard reef:signal-risk-selection', event.detail)
      this.hidden = !this.shouldShow(Array.from(event.detail))
    }), 50)
  }

  render(noticeHeading, noticeBody) {
    this.innerHTML = `<h2>${noticeHeading}</h2>
        <div class="flow notice-inner">${noticeBody}</div>`
  }

  shouldShow(formSelections, assessmentId) {
    const validSelections = formSelections.filter((f) => isValidAssessmentItemId(f, assessmentId))

    if (this.showCondition === 'none' && validSelections.length === 0) {
      return true
    } else if (this.showCondition === 'any' && validSelections.length > 0) {
      return true
    } else {
      const parsedConditions = this.showCondition.split(/\s*,\s*/)
      return parsedConditions.some((c) => validSelections.includes(c))
    }
  }
}
